<h1 fxLayoutAlign="center">Apply Now</h1>

<div fxLayout="row" fxLayout.xs="column" fxLayoutAlign="space-around">
  <mat-card fxLayout="column" *ngIf="!submitted">
    <div fxLayout.xs="column">
      <mat-form-field fxFlex="30">
        <input
          required
          matInput
          [formControl]="nameC"
          placeholder="Name"
          [(ngModel)]="candidate.name"
        />
        <mat-error *ngIf="nameC.invalid">Enter a valid name.</mat-error>
      </mat-form-field>

      <mat-form-field fxFlex="30">
        <input
          required
          matInput
          [formControl]="emailC"
          placeholder="Email"
          [(ngModel)]="candidate.email"
          name="email"
        />
        <mat-error *ngIf="emailC.invalid">Enter a valid email.</mat-error>
      </mat-form-field>

      <mat-form-field fxFlex="30">
        <input
          required
          matInput
          [formControl]="phoneC"
          placeholder="Phone"
          [(ngModel)]="candidate.phone"
          name="phone"
        />
        <mat-error *ngIf="phoneC.invalid"
          >Enter a valid 10 digit phone.</mat-error
        >
      </mat-form-field>
    </div>

    <div fxLayout.xs="column">
      <mat-form-field fxFlex="30">
        <input
          required
          matInput
          [formControl]="cityC"
          placeholder="City & State"
          [(ngModel)]="candidate.city"
          name="city"
        />
        <mat-error *ngIf="cityC.invalid">Enter a valid city.</mat-error>
      </mat-form-field>

      <mat-form-field fxFlex="30">
        <input
          required
          matInput
          [formControl]="educationC"
          placeholder="Highest Education"
          [(ngModel)]="candidate.education"
          name="education"
        />
        <mat-error *ngIf="educationC.invalid"
          >Enter valid highest education.</mat-error
        >
      </mat-form-field>

      <mat-form-field fxFlex="30">
        <input
          required
          matInput
          [formControl]="streamC"
          placeholder="Stream in 10+2"
          [(ngModel)]="candidate.stream"
          name="stream"
        />
        <mat-error *ngIf="streamC.invalid">Enter a valid stream.</mat-error>
      </mat-form-field>
    </div>

    <div fxLayout.xs="column">
      <mat-form-field fxFlex="30">
        <input
          required
          matInput
          [formControl]="mathsC"
          placeholder="10+2 Maths %"
          [(ngModel)]="candidate.maths"
          name="maths"
        />
        <mat-error *ngIf="mathsC.invalid">Enter a valid %.</mat-error>
      </mat-form-field>

      <mat-form-field fxFlex="30">
        <input
          required
          matInput
          [formControl]="physicsC"
          placeholder="10+2 Physics %"
          [(ngModel)]="candidate.physics"
          name="physics"
        />
        <mat-error *ngIf="physicsC.invalid">Enter a valid %.</mat-error>
      </mat-form-field>

      <mat-form-field fxFlex="30">
        <input
          required
          matInput
          [formControl]="passportC"
          placeholder="Passport No."
          [(ngModel)]="candidate.passport"
          name="passport"
        />
        <mat-error *ngIf="passportC.invalid"
          >Enter a valid Passport No.</mat-error
        >
      </mat-form-field>
    </div>

    <div fxLayoutAlign="center">
      <button
        mat-raised-button
        [disabled]="
          !nameC.valid ||
          !emailC.valid ||
          !phoneC.valid ||
          !cityC.valid ||
          !streamC.valid ||
          !educationC.valid ||
          !mathsC.valid ||
          !physicsC.valid ||
          !passportC.valid
        "
        color="warn"
        (click)="addApplication()"
      >
        Apply
      </button>
    </div>
  </mat-card>

  <mat-card *ngIf="submitted">
    <mat-card-content
      ><p>Applied Succesfully. We will get back to you.</p></mat-card-content
    >
  </mat-card>
</div>
